export enum AdvertisementBoardType {
  Image = "IMAGE",
  Video = "VIDEO",
  QR = "QR",
  LeadPhone = "LEAD_PHONE",
  LeadEmail = "LEAD_EMAIL",
}
